import { render, staticRenderFns } from "./TabSelector.vue?vue&type=template&id=0bde155b&scoped=true&"
import script from "./TabSelector.vue?vue&type=script&lang=ts&"
export * from "./TabSelector.vue?vue&type=script&lang=ts&"
import style0 from "./TabSelector.vue?vue&type=style&index=0&id=0bde155b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bde155b",
  null
  
)

export default component.exports